<div mat-dialog-content [innerHTML]="message | trustHtml"></div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="onNoClick()">No</button>
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</div>
